export function getPersistKey(key: string, prefix: string) {
  return `${prefix}:${key}`
}
